<template>
  <div>
    <form-field-input
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-date-picker
      label="Date"
      v-model="form.date"
      :validation-errors="validationErrors.date"
    ></form-field-date-picker>

    <form-field-input
      label="Unit Count"
      v-model="form.count"
      :validation-errors="validationErrors.count"
      type="number"
    ></form-field-input>

    <form-field-editor
      label="Description"
      v-model="form.description"
      type="snippetNote"
      :validation-errors="validationErrors.description"
    ></form-field-editor>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import dates from "../services/dates";
import api from "../api";

export default {
  name: "CampaignUnitCountForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        label: null,
        date: null,
        count: '',
        description: null,
        campaign_id: '',
      },
    }
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone({...this.defaultForm, ...this.formData}) : this.$utils.clone(this.defaultForm);
  },
  methods: {
    update() {
      const payload = {
        ...this.form,
        date: dates.formatAsDBDate(dates.convertJSDateToISO(new Date(this.form.date))),
      }

      return api.campaignUnitCount.update(payload)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Campaign unit count was updated',
            type: 'is-success'
          });

          return res;
        });
    },
    create() {
      const payload = {
        ...this.form,
        date: dates.formatAsDBDate(dates.convertJSDateToISO(this.form.date))
      }

      return api.campaignUnitCount.create(payload)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Campaign unit count was created',
            type: 'is-success'
          });


          return res;
        });
    },
    delete() {
      return api.campaignUnitCount.delete(this.form.id)
        .then(res => {
          this.$buefy.toast.open({
            message: res.data,
            type: 'is-success'
          });

          return res;
        });
    },
  },
}
</script>

<style scoped>

</style>
